/**
 * Ryan O'Dowd
 * 2024-03-01
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

// @TODO: delete ones that aren't used
const getStyles = ({globalScale, colors}) => {
  return {
    noVerticalPadding: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    headerInfo: {
      marginBottom: globalScale * 16,
    },
    publishedStatusWrapper: {
      display: 'flex',
      marginBottom: 16,
    },
    editRow: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    fullTitleWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    mainTitle: {
      padding: 0,
      margin: 0,
      color: colors.dialogText,
      lineHeight: 1,
    },
    subTitle: {
      color: colors.accentDark,
      fontSize: '0.8em',
      lineHeight: 1,
    },
    actionsWrapper: { // @TODO: abstract with assignment styles
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: 8,
    },
    tableText: {
      color: colors.dialogText,
    },
    progressWrapper: {
      cursor: 'pointer',
    },
  };
};

export default getStyles;
